var _path, _path2, _path3, _path4, _path5, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrderNotification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 61,
    viewBox: "0 0 65 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.1419 55.4076C44.9921 55.4076 56.2205 44.1791 56.2205 30.2795C56.2205 16.38 44.9426 5.15149 31.1419 5.15149C17.2918 5.15149 6.06335 16.38 6.06335 30.2795C6.06335 44.1791 17.2918 55.4076 31.1419 55.4076Z",
    fill: "#EAEEF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8273 47.7395C61.0335 47.7395 62.0114 46.7617 62.0114 45.5555C62.0114 44.3493 61.0335 43.3715 59.8273 43.3715C58.6211 43.3715 57.6433 44.3493 57.6433 45.5555C57.6433 46.7617 58.6211 47.7395 59.8273 47.7395Z",
    fill: "#EAEEF9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0235 39.2164C63.8473 39.2164 64.515 38.5487 64.515 37.7249C64.515 36.9012 63.8473 36.2334 63.0235 36.2334C62.1998 36.2334 61.532 36.9012 61.532 37.7249C61.532 38.5487 62.1998 39.2164 63.0235 39.2164Z",
    fill: "#EAEEF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3643 12.4881C13.1881 12.4881 13.8559 11.8203 13.8559 10.9965C13.8559 10.1728 13.1881 9.505 12.3643 9.505C11.5406 9.505 10.8728 10.1728 10.8728 10.9965C10.8728 11.8203 11.5406 12.4881 12.3643 12.4881Z",
    fill: "#EAEEF9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.25533 41.2531C4.78514 41.2531 6.0253 40.0129 6.0253 38.4831C6.0253 36.9533 4.78514 35.7131 3.25533 35.7131C1.72551 35.7131 0.485352 36.9533 0.485352 38.4831C0.485352 40.0129 1.72551 41.2531 3.25533 41.2531Z",
    fill: "#EAEEF9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dddd_2414_37262)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.4465 42.5771L36.8691 41.66C37.5669 41.473 38.3384 41.9162 38.5635 42.7561L39.0658 44.6308C39.5612 46.4796 38.5926 48.3169 36.9375 48.7604C35.2825 49.2039 33.5249 48.097 33.0295 46.2482L32.5272 44.3735C32.3136 43.5763 32.7515 42.7633 33.4465 42.5771Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.319013
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-1_2414_37262",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9045 10.0414L22.7594 9.49986C22.3239 7.87426 23.2556 6.26106 24.8817 5.82535C26.5078 5.38964 28.1212 6.32086 28.5568 7.94646L28.7019 8.48795C34.7261 8.28009 40.3127 12.2282 41.9395 18.2992L42.3751 19.9248C46.0491 33.6364 56.3112 40.5072 56.3112 40.5072L14.9332 51.5945C14.9332 51.5945 20.4558 40.4941 16.7818 26.7825L16.3462 25.1569C14.7195 19.0859 17.5836 12.8735 22.9045 10.0414Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9045 10.0414L22.7594 9.49986C22.3239 7.87426 23.2556 6.26106 24.8817 5.82535C26.5078 5.38964 28.1212 6.32086 28.5568 7.94646L28.7019 8.48795C34.7261 8.28009 40.3127 12.2282 41.9395 18.2992L42.3751 19.9248C46.0491 33.6364 56.3112 40.5072 56.3112 40.5072L14.9332 51.5945C14.9332 51.5945 20.4558 40.4941 16.7818 26.7825L16.3462 25.1569C14.7195 19.0859 17.5836 12.8735 22.9045 10.0414Z",
    fill: "url(#paint0_linear_2414_37262)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9045 10.0414L22.9645 10.154L23.0541 10.1063L23.0278 10.0083L22.9045 10.0414ZM28.7019 8.48795L28.5786 8.52097L28.6049 8.61897L28.7063 8.61547L28.7019 8.48795ZM41.9395 18.2992L42.0627 18.2662L41.9395 18.2992ZM42.3751 19.9248L42.2518 19.9579L42.3751 19.9248ZM56.3112 40.5072L56.3443 40.6305L56.6159 40.5577L56.3822 40.4012L56.3112 40.5072ZM14.9332 51.5945L14.819 51.5376L14.6929 51.7909L14.9662 51.7177L14.9332 51.5945ZM23.0278 10.0083L22.8827 9.46683L22.6362 9.53288L22.7813 10.0744L23.0278 10.0083ZM22.8827 9.46683C22.4654 7.90934 23.3566 6.36609 24.9147 5.94861L24.8486 5.7021C23.1545 6.15604 22.1824 7.83918 22.6362 9.53288L22.8827 9.46683ZM24.9147 5.94861C26.4727 5.53113 28.0162 6.422 28.4336 7.97948L28.6801 7.91343C28.2262 6.21972 26.5428 5.24816 24.8486 5.7021L24.9147 5.94861ZM28.4336 7.97948L28.5786 8.52097L28.8252 8.45492L28.6801 7.91343L28.4336 7.97948ZM42.0627 18.2662C40.4203 12.1365 34.7797 8.15056 28.6975 8.36042L28.7063 8.61547C34.6725 8.40963 40.2052 12.3198 41.8162 18.3323L42.0627 18.2662ZM42.4983 19.8918L42.0627 18.2662L41.8162 18.3323L42.2518 19.9579L42.4983 19.8918ZM56.3112 40.5072C56.3822 40.4012 56.3822 40.4012 56.3822 40.4012C56.3821 40.4011 56.382 40.4011 56.3819 40.401C56.3816 40.4008 56.3812 40.4005 56.3807 40.4002C56.3795 40.3994 56.3778 40.3982 56.3754 40.3966C56.3707 40.3934 56.3635 40.3885 56.3539 40.3819C56.3348 40.3688 56.3062 40.349 56.2686 40.3225C56.1935 40.2694 56.0823 40.1896 55.9394 40.0829C55.6535 39.8697 55.2402 39.5493 54.7325 39.1218C53.7171 38.2669 52.3242 36.9839 50.8166 35.2735C47.8012 31.8525 44.329 26.7239 42.4983 19.8918L42.2518 19.9579C44.0952 26.8373 47.591 32 50.6252 35.4423C52.1424 37.1635 53.5446 38.4552 54.5682 39.317C55.08 39.748 55.4972 40.0715 55.7868 40.2875C55.9316 40.3955 56.0446 40.4767 56.1215 40.531C56.16 40.5581 56.1894 40.5786 56.2094 40.5923C56.2194 40.5991 56.227 40.6043 56.2321 40.6078C56.2347 40.6096 56.2367 40.6109 56.238 40.6118C56.2387 40.6123 56.2392 40.6126 56.2396 40.6129C56.2398 40.613 56.2399 40.6131 56.24 40.6131C56.2402 40.6132 56.2402 40.6133 56.3112 40.5072ZM14.9662 51.7177L56.3443 40.6305L56.2782 40.384L14.9002 51.4712L14.9662 51.7177ZM16.6585 26.8156C18.4891 33.6474 18.0288 39.8296 17.1102 44.3047C16.651 46.5421 16.0774 48.3519 15.6189 49.6018C15.3897 50.2267 15.1892 50.7116 15.0463 51.0398C14.9749 51.2038 14.9178 51.3288 14.8787 51.4124C14.8592 51.4543 14.8441 51.4858 14.834 51.5067C14.829 51.5172 14.8251 51.525 14.8226 51.5302C14.8213 51.5328 14.8204 51.5347 14.8198 51.5359C14.8195 51.5365 14.8193 51.537 14.8191 51.5373C14.8191 51.5374 14.819 51.5375 14.819 51.5376C14.819 51.5376 14.819 51.5376 14.9332 51.5945C15.0474 51.6513 15.0475 51.6512 15.0476 51.6511C15.0476 51.651 15.0477 51.6508 15.0478 51.6506C15.048 51.6502 15.0483 51.6497 15.0486 51.6489C15.0493 51.6475 15.0504 51.6453 15.0518 51.6425C15.0545 51.6369 15.0586 51.6286 15.0639 51.6176C15.0744 51.5958 15.0899 51.5633 15.1099 51.5205C15.1499 51.4348 15.2079 51.3079 15.2803 51.1416C15.4251 50.8092 15.6274 50.3197 15.8585 49.6897C16.3207 48.4298 16.8981 46.6076 17.3602 44.356C18.2845 39.853 18.7484 33.6292 16.905 26.7495L16.6585 26.8156ZM16.2229 25.19L16.6585 26.8156L16.905 26.7495L16.4695 25.1239L16.2229 25.19ZM22.8446 9.92872C17.4723 12.7881 14.5805 19.0603 16.2229 25.19L16.4695 25.1239C14.8584 19.1115 17.6948 12.9588 22.9645 10.154L22.8446 9.92872Z",
    fill: "black",
    mask: "url(#path-7-inside-1_2414_37262)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dddd_2414_37262",
    x: 12.3811,
    y: 5.71826,
    width: 46.4823,
    height: 54.8086,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.638026
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.319013
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2414_37262"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.27605
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.638026
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2414_37262",
    result: "effect2_dropShadow_2414_37262"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.19013
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.957038
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_2414_37262",
    result: "effect3_dropShadow_2414_37262"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.38026
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.27605
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_2414_37262",
    result: "effect4_dropShadow_2414_37262"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect4_dropShadow_2414_37262",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2414_37262",
    x1: 24.5836,
    y1: 4.90819,
    x2: 35.7249,
    y2: 46.4879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDDD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#FD561F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderNotification);
export default __webpack_public_path__ + "static/media/order-notification.42df78e0806a97ad05d6107aa4e363f2.svg";
export { ForwardRef as ReactComponent };